import SpineAnimation from './SpineAnimation';
import ISymbolSpineAnimConfig from '../managers/contracts/configurations/ISymbolSpineAnimConfig';
import IAnim from '../managers/contracts/animation/IAnim';
import GameModel from '../model/GameModel';
import ISpineAnimStateConfig from '../managers/contracts/configurations/spine_anim/ISpineAnimStateConfig';
import { ISkeletonData } from 'pixi-spine';

export default class SymbolSpineAnimation extends SpineAnimation implements IAnim<ISymbolSpineAnimConfig> {
    public id: number = null;
    public activeSkin: string = "";

    /**
     * Used, when the spine is not skin-based.
     * In this case the animator MUST provide animations which ends with _${desired_skin_name}
     *
     * @private
     * @type {string}
     * @memberof SymbolSpineAnimation
     */
    private animSuffix: string = "";

    //public scale;
    public animConfig: ISymbolSpineAnimConfig;
    constructor(animJson: ISkeletonData, name: string, config: ISymbolSpineAnimConfig) {
        super(animJson, name, config);
    }

    public hasChainingAnim = (chainingAnim: string): boolean => {
        return Boolean(this.animConfig.getSkinConfig(this.activeSkin)?.chainingStates?.find(data => data.name === chainingAnim))
    }

    /**
     * name
     */
    public play(
        animState: string = this.animConfig.getSkinConfig(this.activeSkin || this.animConfig.defaultSkin).defaultState,
        loop: boolean = this.animConfig.getStateConfig(animState)?.loop,
        timeScale?: number,
    ) {
        super.play(`${animState}${this.animSuffix}`, loop, timeScale);
    }

    /**
        name
     */
    public getChainingAnimConfig(chainingAnim: string, skin: string = this.activeSkin) {
        return this.animConfig.getChainingAnimConfig(chainingAnim, skin)
    }

    public getStateConfig(state: string): ISpineAnimStateConfig | undefined {
        return this.animConfig.getStateConfig(state);
    }

    public setActiveSkin = (id: number) => {
        let skin = GameModel.gameConfig.symbolAssetsMap[id].name;
        if (this.activeSkin !== skin) {
            if (this.skeleton.data.findSkin(skin)) {
                this.skeleton.setSkinByName(skin);
                this.activeSkin = skin;
            } else {
                // No such skin. 
                // In this case the animator must provide animations,
                // which ends with the symbol (skin) name, preceded by underscore.
                this.animSuffix = `_${skin}`;
            }

            this.id = id;
        }
    }
}
